import { IconButton, Tooltip } from "@chakra-ui/react";
import { RiDownloadLine } from "@remixicon/react";

import { Restricted } from "@/app/components/Restricted";

interface Props<T> {
  exportUrl: string;
  formFields: T;
}

export function ExportButton<T>({ exportUrl, formFields }: Props<T>) {
  return (
    <Restricted flagKey="csv-export">
      <form action={exportUrl} method="post">
        <Tooltip label="Export to CSV">
          <IconButton
            aria-label="Export to CSV"
            size="sm"
            type="submit"
            variant="outline"
          >
            <RiDownloadLine size={16} />
          </IconButton>
        </Tooltip>
        <input
          name="searchQuery"
          type="hidden"
          value={JSON.stringify(formFields)}
        />
      </form>
    </Restricted>
  );
}
